module.exports = __webpack_public_path__ + "img/admin-tags-assistant.e548097b.webp";